import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const Privateroute = () => {
  const token = window.localStorage.getItem("token");
  const isLoggedIn = !!token;

  return (
    <>
      {isLoggedIn ? <Outlet /> : <Navigate to="/" />}
    </>
  );
};

export default Privateroute;
